module.exports = __webpack_public_path__ + "img/journal-richtext.83d01b36.svg";